import { useEffect, useState } from "react";
import { searchCompaniesByName } from "../../services/companyApi";

const DEFAULT_DEBOUNCE = 250;

export default function useCompanySuggestions(query, { enabled = true, debounce = DEFAULT_DEBOUNCE } = {}) {
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setSuggestions([]);
      setLoading(false);
      return;
    }

    const term = String(query || "").trim();
    if (term.length < 2) {
      setSuggestions([]);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);

    const timeoutId = setTimeout(() => {
      searchCompaniesByName(term)
        .then(items => {
          if (!cancelled) {
            setSuggestions(items);
          }
        })
        .catch(() => {
          if (!cancelled) {
            setSuggestions([]);
          }
        })
        .finally(() => {
          if (!cancelled) {
            setLoading(false);
          }
        });
    }, debounce);

    return () => {
      cancelled = true;
      clearTimeout(timeoutId);
    };
  }, [query, enabled, debounce]);

  return { suggestions, loading };
}
